import { render } from "./NonFungibleFutureRewards.vue?vue&type=template&id=48c8cd62&scoped=true"
import script from "./NonFungibleFutureRewards.vue?vue&type=script&lang=js"
export * from "./NonFungibleFutureRewards.vue?vue&type=script&lang=js"

import "./NonFungibleFutureRewards.vue?vue&type=style&index=0&id=48c8cd62&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48c8cd62"]])

export default __exports__